import {isMobile} from "../pose/util";
const VIDEO_SIZE = {
  // 'full': {width: window.innerWidth, height: window.innerHeight},
  'full': {width: 1280, height: 960},
  '640 X 480': {width: 640, height: 480},
  '640 X 360': {width: 640, height: 360},
  '360 X 270': {width: 360, height: 270}
};
export class WecCam {
  constructor() {
    this.video = document.getElementById('video');
  }

  async setupCamera(cameraParam) {
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      throw new Error('Browser API navigator.mediaDevices.getUserMedia not available');
    }

    const {targetFPS, sizeOption} = cameraParam;
    const $size = VIDEO_SIZE[sizeOption];
    const videoConfig = {
      'audio': false,
      'video': {
        facingMode: 'user',
        // width: isMobile() ? VIDEO_SIZE['360 X 270'].width : $size.width,
        // height: isMobile() ? VIDEO_SIZE['360 X 270'].height : $size.height,
        width: $size.width,
        height: $size.height,
        frameRate: { ideal: targetFPS }
      }
    };
    this.video.srcObject = await navigator.mediaDevices.getUserMedia(videoConfig);
    await new Promise((resolve) => {
      this.video.onloadedmetadata = () => {resolve(video);};
    });

    this.video.play();
    this.video.width = this.video.videoWidth;
    this.video.height = this.video.videoHeight;
  }

  async waitUntilReady() {
    if (this.video.readyState >= 2) {
      return
    }
    return await new Promise((resolve) => {
      this.video.onloadeddata = () => {
        resolve(this.camera.video);
      };
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/common/WecCam.js